import { TransportService } from "./transportService";
const transportService = new TransportService();

const LoginApi = {
  auth: formData => transportService.requestData("Login", formData),
};

export default LoginApi;
